// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=.ts"
// @generated from file qliq_protobuf/apps/vc/chat_widget.proto (package qliq_protobuf.apps.vc, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { LocalizedEntity } from "../../localized_entity_pb.ts";
import { ChatWidgetMessage } from "../../chat_widget_message_pb.ts";
import { QliqAssistedCallerid } from "../../qliq_assisted_callerid_pb.ts";
import { ChatWidgetSmsNumber } from "../../chat_widget_sms_number_pb.ts";
import { ChatWidgetEmrConnection } from "../../chat_widget_emr_connection_pb.ts";
import { VirtualBackgroundImage } from "../../virtual_background_image_pb.ts";
import { PersonType } from "../../person_type_pb.ts";

/**
 * @generated from message qliq_protobuf.apps.vc.ChatWidget
 */
export class ChatWidget extends Message<ChatWidget> {
  /**
   * @generated from field: uint32 id = 1;
   */
  id = 0;

  /**
   * @generated from field: repeated qliq_protobuf.LocalizedEntity name = 2;
   */
  name: LocalizedEntity[] = [];

  /**
   * @generated from field: string description = 3;
   */
  description = "";

  /**
   * @generated from field: string uid = 4;
   */
  uid = "";

  /**
   * @generated from field: bool disable_chat_attachments = 5;
   */
  disableChatAttachments = false;

  /**
   * @generated from field: bool disable_chat_emojis = 6;
   */
  disableChatEmojis = false;

  /**
   * @generated from field: bool hide_all_conversations_tab = 7;
   */
  hideAllConversationsTab = false;

  /**
   * @generated from field: bool hide_closed_conversations_tab = 8;
   */
  hideClosedConversationsTab = false;

  /**
   * @generated from field: uint32 maximum_attachment_size = 9;
   */
  maximumAttachmentSize = 0;

  /**
   * @generated from field: repeated string restrict_attachment_types = 10;
   */
  restrictAttachmentTypes: string[] = [];

  /**
   * @generated from field: qliq_protobuf.apps.vc.ChatWidget.ConversationRule conversation_rule = 11;
   */
  conversationRule?: ChatWidget_ConversationRule;

  /**
   * @generated from field: repeated qliq_protobuf.ChatWidgetMessage messages = 12;
   */
  messages: ChatWidgetMessage[] = [];

  /**
   * @generated from field: bool is_post_video_call_feedback_enabled = 13;
   */
  isPostVideoCallFeedbackEnabled = false;

  /**
   * @generated from field: qliq_protobuf.QliqAssistedCallerid qliq_assisted_callerid = 14;
   */
  qliqAssistedCallerid?: QliqAssistedCallerid;

  /**
   * @generated from field: repeated qliq_protobuf.ChatWidgetSmsNumber chat_widget_sms_numbers = 15;
   */
  chatWidgetSmsNumbers: ChatWidgetSmsNumber[] = [];

  /**
   * @generated from field: repeated qliq_protobuf.ChatWidgetEmrConnection chat_widget_emr_connections = 16;
   */
  chatWidgetEmrConnections: ChatWidgetEmrConnection[] = [];

  /**
   * @generated from field: bool emr_integration_enabled = 17;
   */
  emrIntegrationEnabled = false;

  /**
   * @generated from field: bool voice_calls_for_virtual_conversations_enabled = 18;
   */
  voiceCallsForVirtualConversationsEnabled = false;

  /**
   * @generated from field: qliq_protobuf.VirtualBackgroundImage virtual_background_image = 19;
   */
  virtualBackgroundImage?: VirtualBackgroundImage;

  /**
   * @generated from field: bool enable_virtual_background = 20;
   */
  enableVirtualBackground = false;

  /**
   * @generated from field: repeated string sms_restrict_country_codes = 21;
   */
  smsRestrictCountryCodes: string[] = [];

  /**
   * @generated from field: bool can_select_bot_design = 22;
   */
  canSelectBotDesign = false;

  /**
   * @generated from field: string owner_name = 23;
   */
  ownerName = "";

  /**
   * @generated from field: bool is_sending_mms = 24;
   */
  isSendingMms = false;

  /**
   * @generated from field: qliq_protobuf.PersonType person_type = 25;
   */
  personType = PersonType.PERSON_UNKNOWN;

  /**
   * @generated from field: bool is_quick_sign_subscribed = 26;
   */
  isQuickSignSubscribed = false;

  /**
   * @generated from field: bool is_virtual_visits_subscribed = 27;
   */
  isVirtualVisitsSubscribed = false;

  /**
   * @generated from field: bool is_screensharing_calls_subscribed = 28;
   */
  isScreensharingCallsSubscribed = false;

  /**
   * @generated from field: repeated qliq_protobuf.apps.vc.ChatWidget.PatientGroup patient_groups = 29;
   */
  patientGroups: ChatWidget_PatientGroup[] = [];

  constructor(data?: PartialMessage<ChatWidget>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.apps.vc.ChatWidget";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "name", kind: "message", T: LocalizedEntity, repeated: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "uid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "disable_chat_attachments", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "disable_chat_emojis", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "hide_all_conversations_tab", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "hide_closed_conversations_tab", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "maximum_attachment_size", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 10, name: "restrict_attachment_types", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "conversation_rule", kind: "message", T: ChatWidget_ConversationRule },
    { no: 12, name: "messages", kind: "message", T: ChatWidgetMessage, repeated: true },
    { no: 13, name: "is_post_video_call_feedback_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "qliq_assisted_callerid", kind: "message", T: QliqAssistedCallerid },
    { no: 15, name: "chat_widget_sms_numbers", kind: "message", T: ChatWidgetSmsNumber, repeated: true },
    { no: 16, name: "chat_widget_emr_connections", kind: "message", T: ChatWidgetEmrConnection, repeated: true },
    { no: 17, name: "emr_integration_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "voice_calls_for_virtual_conversations_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "virtual_background_image", kind: "message", T: VirtualBackgroundImage },
    { no: 20, name: "enable_virtual_background", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 21, name: "sms_restrict_country_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 22, name: "can_select_bot_design", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 23, name: "owner_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "is_sending_mms", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 25, name: "person_type", kind: "enum", T: proto3.getEnumType(PersonType) },
    { no: 26, name: "is_quick_sign_subscribed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 27, name: "is_virtual_visits_subscribed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 28, name: "is_screensharing_calls_subscribed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 29, name: "patient_groups", kind: "message", T: ChatWidget_PatientGroup, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChatWidget {
    return new ChatWidget().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChatWidget {
    return new ChatWidget().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChatWidget {
    return new ChatWidget().fromJsonString(jsonString, options);
  }

  static equals(a: ChatWidget | PlainMessage<ChatWidget> | undefined, b: ChatWidget | PlainMessage<ChatWidget> | undefined): boolean {
    return proto3.util.equals(ChatWidget, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.apps.vc.ChatWidget.ConversationRule
 */
export class ChatWidget_ConversationRule extends Message<ChatWidget_ConversationRule> {
  /**
   * @generated from field: bool is_notify = 1;
   */
  isNotify = false;

  /**
   * @generated from field: bool is_automatic = 2;
   */
  isAutomatic = false;

  /**
   * @generated from field: bool is_bot = 3;
   */
  isBot = false;

  /**
   * @generated from field: uint32 agent_id = 4;
   */
  agentId = 0;

  /**
   * @generated from field: uint32 bot_design_id = 5;
   */
  botDesignId = 0;

  constructor(data?: PartialMessage<ChatWidget_ConversationRule>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.apps.vc.ChatWidget.ConversationRule";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "is_notify", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "is_automatic", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "is_bot", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "agent_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "bot_design_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChatWidget_ConversationRule {
    return new ChatWidget_ConversationRule().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChatWidget_ConversationRule {
    return new ChatWidget_ConversationRule().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChatWidget_ConversationRule {
    return new ChatWidget_ConversationRule().fromJsonString(jsonString, options);
  }

  static equals(a: ChatWidget_ConversationRule | PlainMessage<ChatWidget_ConversationRule> | undefined, b: ChatWidget_ConversationRule | PlainMessage<ChatWidget_ConversationRule> | undefined): boolean {
    return proto3.util.equals(ChatWidget_ConversationRule, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.apps.vc.ChatWidget.PatientGroup
 */
export class ChatWidget_PatientGroup extends Message<ChatWidget_PatientGroup> {
  /**
   * @generated from field: uint32 id = 1;
   */
  id = 0;

  /**
   * @generated from field: string uuid = 2;
   */
  uuid = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  constructor(data?: PartialMessage<ChatWidget_PatientGroup>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.apps.vc.ChatWidget.PatientGroup";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChatWidget_PatientGroup {
    return new ChatWidget_PatientGroup().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChatWidget_PatientGroup {
    return new ChatWidget_PatientGroup().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChatWidget_PatientGroup {
    return new ChatWidget_PatientGroup().fromJsonString(jsonString, options);
  }

  static equals(a: ChatWidget_PatientGroup | PlainMessage<ChatWidget_PatientGroup> | undefined, b: ChatWidget_PatientGroup | PlainMessage<ChatWidget_PatientGroup> | undefined): boolean {
    return proto3.util.equals(ChatWidget_PatientGroup, a, b);
  }
}

